import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';

import { DocumentsModule } from '../documents/documents.module';
import { LazyViewModule } from '../lazy-view/lazy-view.module';
import { AlertMessageModule } from '../shared/alert-message/alert-message.module';
import { BackButtonModule } from '../shared/back-button/back-button.module';
import { PreloadModule } from '../shared/directives/preload/preload.module';
import { SharedComponentsModule } from '../shared/directives/shared-components.module';
import { IconFontModule } from '../shared/icon-font/icon-font.module';
import { InputDialogModule } from '../shared/input-dialog/input-dialog.module';
import { InstrumentationModule } from '../shared/instrumentation/instrumentation.module';
import { SharedTemplatesModule } from '../shared/templates/shared-templates.module';
import { TitleAnnouncerModule } from '../shared/title-announcer/title-announcer.module';
import { FeaturedComponent } from './featured/featured.component';
import { WacStartComponent } from './wac-start.component';
import { WacStartRouting } from './wac-start.routing';

@NgModule({
    imports: [
        WacStartRouting,
        AlertMessageModule,
        CommonModule,
        BackButtonModule,
        IconFontModule,
        InputDialogModule,
        InstrumentationModule,
        DocumentsModule,
        PreloadModule,
        SharedComponentsModule,
        SharedTemplatesModule,
        TitleAnnouncerModule,
        LazyViewModule
    ],
    declarations: [
        FeaturedComponent,
        WacStartComponent
    ]
})

export class WacStartModule { }
